export default "__VITE_ASSET__2086b597__"